import React from "react";
import {
  Dialog,
  Button,
  DialogContent,
  DialogActions,
  Typography
} from "@material-ui/core";

import styles from "./modal.styles";

export default function Modal({ open, handleClose, fecha, btnAceptar }) {
  const classes = styles();

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      disableBackdropClick={true}
      disableEscapeKeyDown={true}
    >
      <Typography variant="h5" align="center">
        {"Soportes recibidos en proceso de verificación"}
      </Typography>
      <DialogContent>
        <Typography variant="h6" align="center" className={classes.fecha}>
          {fecha}
        </Typography>
        <Typography variant="body1">
          La presentación de los soportes por este medio no conlleva la
          aprobación y pago de la factura ni la modificación en acuerdos de
          tiempo y formas de pago ya pactados.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={btnAceptar}
          variant="outlined"
          color="primary"
          autoFocus
        >
          Aceptar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
